<div class="card mb-3">
  <div class="card-header">
    {{ 'authenticated.quality-management.processes.edit.sub_processes.header' | translate }}
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        @if (processVersion) {
          <app-table
            id="dashboard.quality-management.processes.versions.sub-processes.index"
            [replaceParametersInUrl]="{'{process}': process.id, '{version}': processVersion.id}"
            [showBorder]="false"
            [showFavorites]="false"
            [showEditLink]="false"
            [showTopRow]="false"
            [isSubtable]="true"
            [functionList]="showFunctionList"
            [putTableParametersInUrl]="false"
          ></app-table>
        } @else {
          <app-table
            id="dashboard.quality-management.processes.sub-processes.index"
            [replaceParametersInUrl]="{'{process}': process.id}"
            [showBorder]="false"
            [showFavorites]="false"
            [showEditLink]="false"
            [showTopRow]="false"
            [isSubtable]="true"
            [reloadEmitter]="reloadTable$"
            [functionList]="editFunctionList"
            [putTableParametersInUrl]="false"
          ></app-table>
        }
      </div>

      @if (processVersion === undefined) {
        @if (!isAddingSubProcess) {
          <div class="col-12 text-end">
            <button (click)="isAddingSubProcess = true" type="button" class="btn btn-primary">
              {{ 'authenticated.quality-management.processes.edit.sub_processes.create.btn' | translate }}
            </button>
          </div>
        } @else {
          <div class="col-12">
            <form [formGroup]="form" class="row">
              <div class="col-12">
                <app-multi-select-with-service-list
                  [formControl]="form.controls.sub_process_id"
                  label="{{ 'authenticated.quality-management.processes.edit.sub_processes.form.sub_process_id.label' | translate }}"
                  [searchOnField]="'title'"
                  [sort]="'id'"
                  [selectionMode]="'single_id'"
                  name="sub_process_id"
                  [service]="addableProcessesService"
                  [disableLocalCache]="true"
                ></app-multi-select-with-service-list>
              </div>

              <div class="col-12 pt-3 text-lg-end">
                <button (click)="cancelAddingSubProcess()" type="button" class="btn btn-outline-danger me-3">
                  {{ 'authenticated.quality-management.processes.edit.sub_processes.create.cancel_btn' | translate }}
                </button>
                <button (click)="addSubProcess()" type="button" class="btn btn-primary">
                  {{ 'authenticated.quality-management.processes.edit.sub_processes.create.submit_btn' | translate }}
                </button>
              </div>

            </form>
          </div>
        }
      }

    </div>
  </div>
</div>
